import type { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/core/components/ui/badge";
import type { ApVendor } from "@/accounts-payable/types";

// Linked vendors show who they're linked to; only "Not linked" gets a badge.
export const serviceTitanCol: ColumnDef<ApVendor> = {
  id: "st",
  header: "ServiceTitan vendor",
  accessorFn: (row) => row.st_vendor_name ?? "",
  meta: { size: "260px" },
  cell: ({ row }) =>
    row.original.st_vendor_id ? (
      <span>{row.original.st_vendor_name}</span>
    ) : (
      <Badge variant="gold" size="sm">
        Not linked
      </Badge>
    ),
};
